var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'--main-color':_vm.mainColor})},[_c('v-app',[_c('v-container',{staticClass:"apo-content"},[_c('router-view')],1),(_vm.apoId)?_c('v-footer',{attrs:{"app":"","padless":""}},[_c('BottomNavigation')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }